export const story_en = [
  {
    title: "Jadugora: The Forgotten Land",
    text: "Nestled in the heart of East Singhbhum, Jadugora was once a peaceful tribal land where nature flourished. The Adivasi communities lived in harmony with forests and rivers, sustaining themselves with farming and fishing. For centuries, this land was untouched by modern civilization. But all that changed when scientists turned their gaze towards its rocky terrain.",
    image: "/images/Location0.jpg",
  },
  {
    title: "The Discovery of Uranium",
    text: "In the early 1950s, geologists detected unusually high radiation levels in the rocky outcrops of Jadugora. This discovery shocked the scientific community — the region held one of India’s richest uranium deposits, essential for the country's nuclear energy dreams. It was no longer a remote village — it became a national asset overnight.",
    image: "/images/Mine.jpg",
  },
  {
    title: "Mining Begins, People Displaced",
    text: "By 1967, uranium mining had officially begun under UCIL. The transformation was immediate — farmlands were taken over, forests cut down, and entire villages relocated. Compensation was minimal. Promises of jobs and housing fell short. The people who once thrived off the land were now laborers in a system they never asked for.",
    image: "/images/mining.jpg",
  },
  {
    title: "The People Who Endured",
    text: "Decades passed, and Jadugora's people adapted — not by choice, but by necessity. Miners descended into radioactive shafts every day, without full knowledge of the dangers. Their families lived beside tailing ponds and contaminated soil. Their lives became a blend of survival and silence — stories that rarely reached beyond their village borders.",
    image: "/images/peoples.jpg",
  },
  {
    title: "An Unseen Health Crisis",
    text: "Slowly but steadily, health began to deteriorate. Hospitals started documenting rising cases of bone cancer, skin diseases, infertility, and stillbirths. Children were born with deformities. Most people didn’t understand radiation — they just saw sickness spreading. With limited healthcare, suffering became routine. Even local doctors feared long-term exposure.",
    image: "/images/doctor.jpeg",
  },
  {
    title: "Toxic Waste, Uncovered",
    text: "Radioactive waste from the mines was collected in tailing ponds — open, shallow pits with minimal lining or safety mechanisms. During monsoons, these ponds overflowed into nearby land and streams. Animals died mysteriously. Crops failed. Trees stopped flowering. The land was crying, but no one outside seemed to listen.",
    image: "/images/Radioactive_river.jpg",
  },
  {
    title: "Polluted Rivers, Dying Waters",
    text: "The sacred rivers that once nourished life now carried poison. Villagers who bathed or drank from them fell ill. Fish populations declined. Water-borne diseases rose sharply. The contamination wasn’t just physical — it eroded trust in nature. Women stopped sending children to fetch water. Plastic tanks replaced rivers.",
    image: "/images/River.jpg",
  },
  {
    title: "Farmers in Ruin",
    text: "For those who stayed farmers, the challenges were unbearable. Soil lost its fertility. Rainwater mixed with chemical residues from mining sites. Even when crops grew, they looked abnormal. Many farmers abandoned their fields. Some migrated to cities. Others, broken by debt and despair, chose silence — or worse.",
    image: "/images/farmer.jpeg",
  },
  {
    title: "Ranikini: A Village of Pain",
    text: "Ranikini, a small hamlet near Jadugora, became infamous for its suffering. Cancer touched nearly every home. Families lost multiple members over the years. Government surveys denied any direct radiation link, but the villagers knew what was happening. 'We are experiments,' one woman said, cradling her sick child. 'No one hears us.'",
    image: "/images/ranikini.jpg",
  },
  {
    title: "When Silence Broke: Protests",
    text: "Eventually, silence turned to resistance. Activists, students, and villagers marched through Jadugora. They held public hearings, wrote petitions, and blocked roads. Some were arrested. Others were threatened. But the protests persisted. The demand was simple: clean air, clean water, and dignity. Yet the responses came in hollow promises.",
    image: "/images/protest.jpg",
  },
  {
    title: "Tourism or Tragedy?",
    text: "In recent years, curiosity about 'Uranium City' attracted visitors. Some came to study; others, to take photos of glowing soil and industrial decay. But for the people here, it’s not a tourist spot — it’s a daily battle. Behind every photo lies a family’s pain. The radiation may be invisible, but its effects aren’t.",
    image: "/images/Tourism.jpg",
  }
  // {
  //   title:"Thank You",
  // }
];



export const story_hi = [
  {
    title: "जादूगोड़ा: एक भूली हुई धरती",
    text: "पूर्वी सिंहभूम की गोद में बसा जादूगोड़ा कभी एक शांत आदिवासी इलाका था, जहाँ जंगल, नदियाँ और जमीनें जीवन का आधार थीं। लोग खेती और मछली पकड़कर अपनी आजीविका चलाते थे। सैकड़ों सालों तक यह क्षेत्र आधुनिक दुनिया से दूर रहा। लेकिन जब वैज्ञानिकों की नज़र इसकी चट्टानों पर पड़ी, तो सब बदल गया।",
    image: "/images/Location0.jpg",
  },
  {
    title: "यूरेनियम की खोज",
    text: "1950 के दशक की शुरुआत में, वैज्ञानिकों ने जादूगोड़ा की चट्टानों में अत्यधिक विकिरण की उपस्थिति दर्ज की। यह खोज चौंकाने वाली थी — यहां भारत के सबसे समृद्ध यूरेनियम भंडारों में से एक मौजूद था। यह यूरेनियम देश के परमाणु ऊर्जा सपनों के लिए जरूरी था। एक पल में यह छोटा गांव एक रणनीतिक 'राष्ट्रीय संपत्ति' बन गया।",
    image: "/images/Mine.jpg",
  },
  {
    title: "खान शुरू हुई, लोग उजड़ गए",
    text: "1967 में यूरेनियम खनन का काम UCIL के अधीन शुरू हुआ। खेतों को कब्जे में लिया गया, जंगल काटे गए, गांव खाली कराए गए। मुआवजा नाममात्र का था, और जिन नौकरियों और मकानों का वादा किया गया था, वो अधूरे रह गए। जो लोग कभी ज़मीन के मालिक थे, वो अब एक व्यवस्था में मजदूर बन गए।",
    image: "/images/mining.jpg",
  },
  {
    title: "जिन्होंने सहा सब कुछ",
    text: "समय बीतता गया और जादूगोड़ा के लोग परिस्थितियों के आगे झुकने लगे। हर दिन मज़दूर खदानों में उतरते थे, बिना ये जाने कि वो धीमे ज़हर के संपर्क में हैं। उनके परिवार जहरीली मिट्टी और टेलिंग पॉन्ड के पास रहते थे। ये ज़िंदगी थी — एक संघर्ष जिसमें न तो आवाज़ थी और न ही सुनने वाला कोई।",
    image: "/images/peoples.jpg",
  },
  {
    title: "एक अदृश्य स्वास्थ्य संकट",
    text: "धीरे-धीरे बीमारियाँ बढ़ने लगीं। अस्पतालों में कैंसर, त्वचा रोग, बांझपन और मरे हुए बच्चों की संख्या बढ़ने लगी। कई बच्चों का जन्म विकृतियों के साथ हुआ। लोगों को विकिरण के बारे में ज़्यादा जानकारी नहीं थी, लेकिन वो महसूस कर रहे थे कि कुछ तो बहुत गलत हो रहा है। स्थानीय डॉक्टर भी डरे हुए थे।",
    image: "/images/doctor.jpeg",
  },
  {
    title: "जहरीला कचरा, खुली सच्चाई",
    text: "खनन से निकला जहरीला कचरा खुले टेलिंग पॉन्ड्स में जमा किया जाता है — बिना सुरक्षा के। बरसात में यह जहरीला पानी आसपास की जमीन और नालों में बह जाता है। मवेशी मरने लगे, फसलें सूखने लगीं, पेड़ों पर फूल आना बंद हो गया। धरती रो रही थी, लेकिन बाहर की दुनिया खामोश थी।",
    image: "/images/Radioactive_river.jpg",
  },
  {
    title: "नदियाँ भी ज़हर बनीं",
    text: "जो नदियाँ कभी जीवन देती थीं, अब बीमारी फैलाने लगीं। पानी पीने या नहाने वाले लोग बीमार पड़ने लगे। मछलियाँ गायब हो गईं, दस्त और त्वचा रोग आम हो गए। महिलाएं अब बच्चों को नदी से पानी लाने नहीं भेजतीं। पानी के मटके और प्लास्टिक टैंक अब आस्था की जगह ले चुके हैं।",
    image: "/images/River.jpg",
  },
  {
    title: "किसानों की टूटती उम्मीदें",
    text: "जो लोग खनन के बावजूद किसान बने रहे, उनके लिए जीवन बहुत कठिन हो गया। मिट्टी में अब उपज नहीं रही, पानी जहरीला हो गया। फसलें उगती थीं, लेकिन उनकी शक्ल अजीब होती थी। कई किसान खेत छोड़कर शहर चले गए। कुछ ने कर्ज के बोझ में आत्महत्या कर ली।",
    image: "/images/farmer.jpeg",
  },
  {
    title: "रानीकीनी: दर्द से भरा गांव",
    text: "जादूगोड़ा के पास का गांव रानीकीनी अब बीमारी का प्रतीक बन चुका है। हर घर में कोई न कोई कैंसर से पीड़ित है। कई परिवारों ने सालों में दो या तीन सदस्यों को खो दिया है। सरकारी रिपोर्ट्स विकिरण को जिम्मेदार नहीं मानतीं, लेकिन गांव वाले जानते हैं कि सच्चाई क्या है।",
    image: "/images/ranikini.jpg",
  },
  {
    title: "जब खामोशी टूटी",
    text: "एक समय ऐसा भी आया जब लोग चुप नहीं रहे। स्थानीय लोग, छात्र, और सामाजिक कार्यकर्ता सड़कों पर उतरे। उन्होंने धरने दिए, रैलियाँ निकालीं, और न्याय की मांग की। कुछ को गिरफ्तार किया गया, कई को धमकियाँ मिलीं — लेकिन आंदोलन रुका नहीं। लोगों का संघर्ष जारी है।",
    image: "/images/protest.jpg",
  },
  {
    title: "पर्यटन या त्रासदी?",
    text: "आजकल कुछ लोग जादूगोड़ा को देखने आते हैं — 'यूरेनियम शहर' कहकर। कुछ अध्ययन करने, कुछ तस्वीरें लेने। लेकिन यहां के लोगों के लिए ये एक रोज़ की लड़ाई है, कोई पर्यटन स्थल नहीं। हर तस्वीर के पीछे एक परिवार की पीड़ा है। विकिरण भले ही अदृश्य हो, उसका असर हर जगह है।",
    image: "/images/Tourism.jpg",
  }
  // {
  //   title : "धन्यवाद ",
  // }
];










